import React, { useCallback, useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useReduxSelector } from "@hooks/useReduxSelector";
import {
  disciplinaryActions,
  disciplinaryCategoryActions,
  disciplinaryEnterpriseActions,
  disciplinaryGradationActions
} from "@store/actions";

import AddDisciplinaryForm from "./AddDisciplinaryForm";
import DisciplinaryListTable from "./DisciplinaryListTable";
import ModalAddDisciplinary from "./ModalAddDisciplinary";

function SectionContainerDisciplinary(props) {
  const { employeeId, readOnly = false } = props;
  const [_showModalAddDisciplinary, setShowModalAddDisciplinary] =
    useState(false);
  const [disciplinaryToEdit, setDisciplinaryToEdit] = useState();
  const disciplinaryList = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.disciplinary
  );
  const currentList = disciplinaryList.employeId === employeeId ? disciplinaryList.list : [];
  const [isLoading, setIsLoading] = useState(false);

  const toggleModalDisciplinaryForm = useCallback((disciplinary) => {
    setShowModalAddDisciplinary(
      (_showModalAddDisciplinary) => !_showModalAddDisciplinary
    );
    if (disciplinary) {
      setDisciplinaryToEdit(disciplinary);
    }
  }, []);

  const reduxDispatch = useDispatch();

  useEffect(() => {
      let active = true;
      setIsLoading(true);
      const load = async () => {
        try {
          reduxDispatch(disciplinaryCategoryActions.loadData);
          reduxDispatch(disciplinaryGradationActions.loadData);
          reduxDispatch(disciplinaryEnterpriseActions.loadData);
          reduxDispatch(disciplinaryActions.loadData(employeeId));
        } finally {
          if (active) setIsLoading(false);
        }
      };
      load();
      return () => { active = false; };
    }, [employeeId, reduxDispatch]);

  return (
    <div className="arh-pb-8 arh-pl-24 arh-pr-12">
      {!readOnly && (
        <AddDisciplinaryForm
          employeeId={employeeId}
          disciplinaryList={currentList}
          toggleModalDisciplinaryForm={toggleModalDisciplinaryForm}
          showModalAddDisciplinary={_showModalAddDisciplinary}
        />
      )}

      <DisciplinaryListTable
        disciplinaryList={currentList}
        isLoading={isLoading}
        readOnly={readOnly}
        toggleModalDisciplinaryForm={toggleModalDisciplinaryForm}
      />

      <ModalAddDisciplinary
        isOpen={_showModalAddDisciplinary}
        closeModal={toggleModalDisciplinaryForm}
        disciplinary={disciplinaryToEdit}
        employeeId={employeeId}
      />
    </div>
  );
}

export default SectionContainerDisciplinary;
